module.exports = __webpack_public_path__ + "static/media/Sallie-Oops.9691c9c3.png";